import signalQuality0 from './../../../images/signalQuality0.png';
import signalQuality1 from './../../../images/signalQuality1.png';
import signalQuality2 from './../../../images/signalQuality2.png';
import signalQuality3 from './../../../images/signalQuality3.png';
import signalQuality4 from './../../../images/signalQuality4.png';
import signalQuality5 from './../../../images/signalQuality5.png';

export default class Controller {

    static get $inject() {
        return [
            '$rootScope', '$timeout', 'ApiPanelsService', 'RemoteAccessService', 'ControlPanelConfigService', '$filter',
            '$q', 'LanguageService', '$state', 'UiHelper', 'gettext', '$element', 'PermissionsService', '$stateParams',
            'toaster', 'ApiAccountService', '$scope', 'ModalDialogService', '$interval', 'moment', 'UserCodeModalService',
            'UserCodeService', 'CountdownService', 'ConfigEmailNotificationService', 'UtilsService', 'EventHelperService'
        ];
    }

    _rssiMinLevel1 = 11;
    _rssiMinLevel2 = 16;
    _rssiMinLevel3 = 20;
    _rssiMinLevel4 = 24;
    _rssiMinLevel5 = 28;

    constructor($rootScope, $timeout, ApiPanelsService, RemoteAccessService, ControlPanelConfigService, $filter,
                $q, LanguageService, $state, UiHelper, gettext, $element, PermissionsService, $stateParams,
                toaster, ApiAccountService, $scope, ModalDialogService, $interval, moment, UserCodeModalService,
                UserCodeService, CountdownService, ConfigEmailNotificationService, UtilsService, EventHelperService) {

        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$q = $q;
        this.LanguageService = LanguageService;
        this.$state = $state;
        this.UiHelper = UiHelper;
        this.gettext = gettext;
        this.$element = $element;
        this.PermissionsService = PermissionsService;
        this.$stateParams = $stateParams;
        this.toaster = toaster;
        this.ApiAccountService = ApiAccountService;
        this.$scope = $scope;
        this.ModalDialogService = ModalDialogService;
        this.$interval = $interval;
        this.moment = moment;
        this.UserCodeModalService = UserCodeModalService;
        this.UserCodeService = UserCodeService;
        this.CountdownService = CountdownService;
        this.ConfigEmailNotificationService = ConfigEmailNotificationService;
        this.EventHelperService = EventHelperService;
        // --- Private vars ---------------------------------------------------------------------------------------
        this.panelId = this.$rootScope.panelId;
        this.VERSION = this.$rootScope.version;
        this.panelName = this.$rootScope.panelName;
        this.isPanicEnabled = this.$rootScope.isPanicEnabled;
        this.mac = this.$rootScope.mac;
        this.$timeout = $timeout;
        this._PanelsService = ApiPanelsService;
        this.UtilsService = UtilsService;
        this.updateOKText = this.getTranslatableText(this.gettext('updated successfully'));
        this.errorText = this.getTranslatableText(this.gettext("An error has occurred, please try again later"));
        this.popMessage = (message, type = "success") => {
            this.toaster.clear();
            this.toaster.pop(type, null, message, 2500);
        };
        this._RemoteAccessService = RemoteAccessService;
        this._isSerenityPanel = this.isSerenityPanel();
        if (this.VERSION != undefined) {
            this.$scope.isVersion84Upper = this.UtilsService.versionCompare(this.VERSION, '0.9.84.0') >= 0;
            this.$scope.isVersion82Upper = this.UtilsService.versionCompare(this.VERSION, '0.9.82.0') >= 0;
            this.$scope.isKeypadNameConfigurable = this.$scope.isVersion84Upper && !this._isSerenityPanel;
        }
        // --- Public vars ----------------------------------------------------------------------------------------
        this.busy = false;
        this.isGenericStatisticsInterface = false;
        this.genericDeviceStatisticsInterface = "32768";
        this._batteryVoltageKey = 'battery_voltage';
        this._offset = 0;
        this.currentDuration = 'hour';
        this.selectedStatisticsLoading = false;
        this._outputGraphModalId = '#outputGraphModal';
        this._zoneGraphModalId = '#zoneGraphModal';

        // === Consts vars ----------------------------------------------------------------------------------------
        this.ControlPanelConfigService = ControlPanelConfigService;
        this.DEVICE_TYPE = this.ControlPanelConfigService.DEVICE_TYPE;
        this.INTERFACES = this.ControlPanelConfigService.INTERFACES;
        this.DEVICE_INTERFACES = this.ControlPanelConfigService.DEVICE_INTERFACES;
        this.HAN_UNIT_TYPE = this.ControlPanelConfigService.HAN_UNIT_TYPE;

        // --- Helpers --------------------------------------------------------------------------------------------
        this.resetGeneralAlarms = function () {
            return this._RemoteAccessService.resetGeneralAlarms(this.panelId);
        };
        this.getDectOutputLastMeasurements = function (outputId, interfaceType) {

            return this._PanelsService.getDectOutputLastMeasurements(this.panelId, outputId, interfaceType);
        };
        this.getDectZoneLastMeasurements = function (zoneId, interfaceType) {

            return this._PanelsService.getDectZoneLastMeasurements(this.panelId, zoneId, interfaceType);
        };

        this.getDectKeypadLastMeasurements = function (zoneId, interfaceType) {

            return this._PanelsService.getDectKeypadLastMeasurements(this.panelId, zoneId, interfaceType);
        };

        this.statisticalConversionFunctions = {
            'temperature': this.getTemperatureConversion,
            '_max_temperature': this.getTemperatureConversion,
            '_min_temperature': this.getTemperatureConversion,
            'humidity': this.getHumidityConversion,
            '_max_humidity': this.getHumidityConversion,
            '_min_humidity': this.getHumidityConversion,
            'battery_voltage': this.getBatteryVoltageConversion,
            'genericDeviceStatistics': this.getFixedGenericDeviceStatistics,
        };

        this.registerToGraphsEvents();
        this.ModalDialogService.setActive();

        this.$element.on('$destroy', () => {

            if (!this.ModalDialogService.isModalClosed) {
                this.ModalDialogService.setInactive();
            }
            this.UserCodeModalService.close();
            this.ConfigEmailNotificationService.close();
        })
    }

    _onSocketEventUpdateZoneAttribute(eventObj, key, sectionProperty, findDeviceFuncRef) {
        let sectionIndex = _.indexOf(eventObj.sections, sectionProperty);
        let deviceId = eventObj.indexes[sectionIndex];
        let device = findDeviceFuncRef(deviceId);

        if (device) {
            if (device[key] !== eventObj.value) {
                device[key] = eventObj.value;
                this.$scope.$apply();
            }
        }
    }

    getEmergencyPhoneNumbers() {
        return this._PanelsService.getEmergencyPhone(this.panelId);
    }

    getPhoneNumbers() {
        return this._PanelsService.getPhoneNumbers(this.panelId);
    }

    _setEmailNotificationObjects() {

        for (let i = 0; i < this.notificationsAddresses.length; i++) {
            this.notificationsAddresses[i].uiId = i + 1;
        }
    }

    getEmailNotification() {
        this.loading = true;
        this.ApiPanelsService.getEmailNotification(this.panelId).then(r => {

            this.notificationsAddresses = r.data.results;
            this._setEmailNotificationObjects();
        }).catch(() => {
        })
            .finally(() => {
                    this.loading = false;
                }
            )
    }

    onEditEmailClick(notifiedEmailItem) {
        this.ConfigEmailNotificationService.showModal(this.panelId, notifiedEmailItem).result.then(() => {
            this.getEmailNotification();
        }).catch(() => {

        });
    }

    _setTimeoutGraphLoading(graphTypeStr, offset, funcPointer) {
        //timeout for modal loading
        setTimeout(() => {
            this.genericLoadGraph(this._statisticGraphChartBindToName, graphTypeStr, funcPointer, offset);
        }, 200);
    }

    isHavePermission(permission) {
        return this.PermissionsService.isHavePermission(permission);
    }

    getDectDescription(dectType) {
        let dectObj = _.find(this.HAN_UNIT_TYPE, {'subType': dectType});

        if (dectObj) {
            dectObj = dectObj.deviceDescription
        }
        return dectObj;
    }

    askUserCode() {
        let userCode = this.UserCodeService.getUserCode();

        if (userCode) {
            return Promise.resolve(userCode);
        }
        return this.UserCodeModalService.showUserCodeModal().result;
    }

    getRssiImage(rssiValue) {

        let signalsImage = null;

        if (rssiValue == 0) {

            signalsImage = signalQuality0;

        } else if (rssiValue == 1) {

            signalsImage = signalQuality1;

        } else if (rssiValue == 2) {

            signalsImage = signalQuality2;

        } else if (rssiValue == 3) {

            signalsImage = signalQuality3;

        } else if (rssiValue == 4) {

            signalsImage = signalQuality4;

        } else if (rssiValue == 5) {

            signalsImage = signalQuality5;
        }

        return signalsImage;
    }

    registerToGraphsEvents() {

        this._registerToGraphCloseEvent(this._outputGraphModalId);
        this._registerToGraphCloseEvent(this._zoneGraphModalId);
    }

    _registerToGraphCloseEvent(id) {

        $(id).on('hidden.bs.modal', () => {
            this.resetLineChart();

        });
    }

    isSerenityPanel() {

        if (this.VERSION) {
            return this.VERSION.startsWith('1', 0);
        } else {
            return false;
        }
    }

    isVersion(versionNumber) {

        if (this.VERSION) {
            return this.VERSION == versionNumber;
        } else {
            return undefined;
        }
    }

    getDectOutputMeasurements(outputId, interfaceId, durationStr, offset) {

        return this._PanelsService.getDectOutputMeasurements(this.panelId, outputId, interfaceId, durationStr, offset);
    }

    getDectZoneMeasurements(zoneId, interfaceId, durationStr, offset) {

        return this._PanelsService.getDectZoneMeasurements(this.panelId, zoneId, interfaceId, durationStr, offset);
    }

    getGSMConnectionMeasurements(zoneId, interfaceId, durationStr, offset) {

        return this._PanelsService.getGSMConnectionMeasurements(this.panelId, zoneId, interfaceId, durationStr, offset);
    }

    getWifiConnectionMeasurements(zoneId, interfaceId, durationStr, offset) {

        return this._PanelsService.getWifiConnectionMeasurements(this.panelId, zoneId, interfaceId, durationStr, offset);
    }

    getZoneGenericStatisticsMeasurements(zoneId, interfaceId, durationStr, offset) {

        return this._PanelsService.getZoneGenericStatisticsMeasurements(this.panelId, zoneId, interfaceId, durationStr, offset);
    }

    getOutputGenericStatisticsMeasurements(zoneId, interfaceId, durationStr, offset) {

        return this._PanelsService.getOutputGenericStatisticsMeasurements(this.panelId, zoneId, interfaceId, durationStr, offset);
    }

    getKeypadGenericStatisticsMeasurements(zoneId, interfaceId, durationStr, offset) {

        return this._PanelsService.getKeypadGenericStatisticsMeasurements(this.panelId, zoneId, interfaceId, durationStr, offset);
    }

    loadLastOutputStatistics(output, openModal = true) {
        this.setCurrentChosenDeviceForStatistics(output);
        this.loadLastStatistics(output.id, output.type, this.getDectOutputLastMeasurements.bind(this), openModal);
    }

    loadLastZoneStatistics(zone, openModal = true) {
        this.setCurrentChosenDeviceForStatistics(zone);
        this.loadLastStatistics(zone.id, zone.type, this.getDectZoneLastMeasurements.bind(this), openModal);
    }

    loadLastKeypadStatistics(keypad, openModal = true) {
        this.setCurrentChosenDeviceForStatistics(keypad);
        this.loadLastStatistics(keypad.id, keypad.type, this.getDectKeypadLastMeasurements.bind(this), openModal);
    }

    setCurrentChosenDeviceForStatistics(deviceObject) {
        this.currentChosenDeviceForStatistics = deviceObject;
    }

    setCurrentDeviceStatisticsParams(deviceId, deviceType) {
        this.isGenericStatisticsInterface = false;
        this.currentDeviceStatisticsType = deviceType;
        this.currentDeviceStatisticsId = deviceId;
        this.currentDeviceInterfaces = this.DEVICE_INTERFACES[deviceType];

        if (this.currentDeviceInterfaces) {
            this.currentDeviceInterfacesKeys = Object.keys(this.currentDeviceInterfaces);
        } else {
            this.isGenericStatisticsInterface = true;
            this.currentDeviceInterfacesKeys = [this.genericDeviceStatisticsInterface];
        }

    }

    loadLastStatistics(deviceId, deviceType, promiseFunc, openModal = true) {

        this.setCurrentDeviceStatisticsParams(deviceId, deviceType);

        if (this.currentDeviceInterfaces || this.isGenericStatisticsInterface) {

            this.lastStatistics = {};

            for (let interfaceType of this.currentDeviceInterfacesKeys) {

                this.statisticsLoading = true;

                promiseFunc(this.currentDeviceStatisticsId, interfaceType)

                    .then((lastInterfaceMeasurements) => {

                        let currentLastInterfaceMeasurements = lastInterfaceMeasurements.data[0];
                        this.lastStatistics = _.merge(this.lastStatistics, currentLastInterfaceMeasurements);
                        this.statisticsLoading = false;
                    })
                    .catch(() => {

                        //todo: handle fail..
                        this.statisticsLoading = false;
                    });
            }

            if (openModal === true) {
                this.openConfigModalByTypeId(this.currentDeviceStatisticsType);
            }
        }
    }

    _loadGraph(statisticGraphChartBindToName, deviceStatisticsId, promiseFunc, durationStr = 'hour', onlyCheckNextRequest = false) {

        let currentOffset = this._offset;
        this.resetLineChart();
        this.setBindMeasurementsFunc(promiseFunc);

        if (onlyCheckNextRequest) {

            currentOffset += 1;
        }

        if (this.currentDeviceInterfaces || this.isGenericStatisticsInterface) {

            this.selectedStatisticsLoading = true;
            let promises = [];

            for (let interfaceType of this.currentDeviceInterfacesKeys) {

                if (this._isCurrentInterfaceId(interfaceType) || this.isGenericStatisticsInterface) {
                    promises.push(promiseFunc(deviceStatisticsId, interfaceType, durationStr, currentOffset));
                }

            }

            this.$q.all(promises)
                .then((interfaceMeasurements) => {

                    let flattenData = _.flatten(_.map(interfaceMeasurements, 'data'));

                    if (onlyCheckNextRequest) {
                        this.isPreviousOffset = !(flattenData === undefined || flattenData.length == 0);
                    } else {
                        let filteredData = this._filterDataWithoutZeroAndConvertValueByStatisticalKey(flattenData, this.currentGraphType);
                        let filteredDataForMaximum = this._filterDataWithoutZeroAndConvertValueByStatisticalKey(flattenData, '_max_' + this.currentGraphType);
                        let filteredDataForMinimum = this._filterDataWithoutZeroAndConvertValueByStatisticalKey(flattenData, '_min_' + this.currentGraphType);
                        let graphTypeData = _.map(filteredData, this.currentGraphType);
                        let graphTypeTimeLabels = _.map(filteredData, '_id.panel_time');
                        this._currentMaximumAxisY = _.max(this._getMaximumMapedDataListByKey(filteredDataForMaximum, this.currentGraphType));
                        this._currentMinimumAxisY = _.min(this._getMinimumMapedDataListByKey(filteredDataForMinimum, this.currentGraphType));

                        if (this._currentMaximumAxisY === undefined || this._currentMinimumAxisY === undefined) {

                            this._currentMaximumAxisY = _.max(graphTypeData);
                            this._currentMinimumAxisY = _.min(graphTypeData);
                        }

                        this._createGraph(statisticGraphChartBindToName, this.currentGraphTypeText, graphTypeTimeLabels, graphTypeData, durationStr);

                        if (durationStr != 'hour' && flattenData.length > 0 && flattenData != undefined) {

                            this.loadLineChartMaximumParam(flattenData, this.currentGraphType);
                            this.loadLineChartMinimumParam(flattenData, this.currentGraphType);
                        }

                    }

                    this.selectedStatisticsLoading = false;

                })

                .catch(err => {

                    //todo: handle fail..
                    if (onlyCheckNextRequest) {
                        this.isPreviousOffset = false;
                    }

                    this.selectedStatisticsLoading = false;

                });
        }
    }

    setBindMeasurementsFunc(bindMeasurementsFunc) {

        this.bindMesurementsFunc = bindMeasurementsFunc;
    }

    genericLoadGraph(statisticGraphChartBindToName, graphTypeStr, bindMeasurementsFunc) {
        this.setGraphType(graphTypeStr);
        this._loadGraph(statisticGraphChartBindToName, this.currentDeviceStatisticsId, bindMeasurementsFunc.bind(this), this.currentDuration);
        this._loadGraph(statisticGraphChartBindToName, this.currentDeviceStatisticsId, bindMeasurementsFunc.bind(this), this.currentDuration, true);
    }

    setGraphType(graphTypeStr) {

        this.currentGraphType = graphTypeStr;

        if (graphTypeStr == 'gas_value') {
            this.currentGraphTypeText = 'air_quality'
        } else if (graphTypeStr == 'gas_level') {
            this.currentGraphTypeText = 'air_quality_Level'
        } else {
            this.currentGraphTypeText = this.currentGraphType;
        }
    }

    setCurrentDuration(durationStr) {

        this.currentDuration = durationStr;
    }

    setDefaultOffset() {

        this._offset = 0;
        this.nextOffset();
    }

    previousOffset() {

        this._offset += 1;
        this.isNextOffset = true;
        this._switchCurrentGraphOffset();
    }

    nextOffset() {

        if (this._offset > 0) {

            this._offset -= 1;
            this._switchCurrentGraphOffset();
        }
        if (this._offset == 0) {

            this.isNextOffset = false;
        }
    }

    _switchCurrentGraphOffset() {

        this.genericLoadGraph(this._statisticGraphChartBindToName, this.currentGraphType, this.bindMesurementsFunc, this.currentDuration);
    }

    loadLineChart(graphName, dataList) {

        let data = _.flatten([[graphName], _.reverse(_.map(dataList, function (data) {
            return _.floor(data, 2);
        }))]);
        this.chart.load({columns: [data]});
    }

    switchCurrentGraphDuration(currentDurationStr) {

        // this.currentDuration = currentDurationStr;
        this.setDefaultOffset();
        this.setCurrentDuration(currentDurationStr);
        this.genericLoadGraph(this._statisticGraphChartBindToName, this.currentGraphType,
            this.bindMesurementsFunc, currentDurationStr);
    }

    _getMapedDataListByKey(dataList, paramKey) {

        return _.filter(_.map(dataList, paramKey), function (data) {

            return data <= 0 || data;
        });
    }

    _getMaximumMapedDataListByKey(dataList, paramKey) {

        return this._getMapedDataListByKey(dataList, '_max_' + paramKey);
    }

    _getMinimumMapedDataListByKey(dataList, paramKey) {

        return this._getMapedDataListByKey(dataList, '_min_' + paramKey);
    }

    loadLineChartMaximumParam(dataList, paramKey) {

        let maxDataList = this._getMaximumMapedDataListByKey(dataList, paramKey);
        this.loadLineChart('Maximum', maxDataList);
    }

    loadLineChartMinimumParam(dataList, paramKey) {

        let minDataList = this._getMinimumMapedDataListByKey(dataList, paramKey);
        this.loadLineChart('Minimum', minDataList);
    }

    defaultConversion(value) {

        value = _.floor(value, 2);
        return value;
    }

    getHumidityConversion(value) {

        value = _.floor(value / 100, 2);
        return value;
    }

    getTemperatureConversion(value) {

        value = _.floor(value / 100, 2);
        return value;
    }

    getBatteryVoltageConversion(value) {
        return _.floor(value / 1000, 2);
    }

    getFixedGenericDeviceStatistics(value) {
        return value;
    }

    _filterDataWithoutZeroAndConvertValueByStatisticalKey(data, statisticalKey) {

        let currentStatisticalKey = angular.copy(statisticalKey);

        if (this.isGenericStatisticsInterface) {
            currentStatisticalKey = 'genericDeviceStatistics';
            if (_.includes(statisticalKey, this._batteryVoltageKey)) {
                currentStatisticalKey = angular.copy(this._batteryVoltageKey);
            }
        }

        let filteredData = _.filter(data, (dataObject) => {

            let currentData = dataObject[statisticalKey];
            dataObject[statisticalKey] = this.getStatisticalConversionValueByKey(currentStatisticalKey, currentData);

            return dataObject[statisticalKey] <= 0 || dataObject[statisticalKey];

        });

        return filteredData
    }

    getStatisticalConversionValueByKey(key, data) {

        return (this.statisticalConversionFunctions[key] || this.defaultConversion)(data);
    }


    _createGraph(bindToId, graphName, labelsList, dataList, xAxisScale = 'hour') {

        if (dataList.length > 0 && dataList != undefined) {

            this.lastBinding = bindToId;
            let chartType = 'line';
            let regions = [
                {axis: 'y', start: this.goodRssiLevel, end: 0, class: 'regionGreen', opacity: 1},
                {axis: 'y', start: this.okRssiLevel, end: this.goodRssiLevel, class: 'regionYellow', opacity: 1},
                {axis: 'y', start: -100, end: this.okRssiLevel, class: 'regionRed', opacity: 1}
            ];
            let showAxisX = false;
            let format = '%d/%m/%y %H:%M';
            let timeSeriesLabels = labelsList.map(timeLabel => {
                return this.castDateTime(timeLabel)
            });

            let labels = _.flatten([['x'], timeSeriesLabels]);
            let data = _.flatten([[this.$filter('humanize')(graphName)], dataList]);

            if (this._currentMaximumAxisY > 0) {
                showAxisX = true;
                this._currentMaximumAxisY *= 1.05;
                this._currentMinimumAxisY *= 0.98;
                regions = [];
                chartType = 'area';
            }

            this.chart = c3.generate({
                bindto: '#' + bindToId,
                data: {
                    x: 'x',
                    xFormat: '%Y-%m-%dT%H:%M:%SZ',
                    // x Format: '%Y%m%d', // 'xFormat' can be used as custom format of 'x'
                    columns: [
                        labels,
                        data,
                    ],
                    type: chartType
                }
                ,
                axis: {
                    x: {
                        show: showAxisX,
                        type: 'timeseries',
                        tick: {
                            format: format
                        }
                    },
                    y: {
                        max: this._currentMaximumAxisY,
                        min: this._currentMinimumAxisY,
                        // Range includes padding, set 0 if no padding needed
                        // padding: {top:0, bottom:0}
                        padding: {
                            bottom: 0
                        },

                        tick: {
                            format: function (d) {
                                return _.round(d, 2);
                            }
                        }
                    }
                },
                zoom: {
                    enabled: true
                },
                point: {
                    show: false
                },
                regions: regions
            });
            this.chart.focus();
        }

    }

    resetLineChart() {

        try {

            if (this.chart != undefined) {

                this._createGraph(this.lastBinding, '', [], []);

            }

            this.chart.destroy();
        } catch (err) {


        }

    }

    openConfigModalByTypeId(typeId) {

        if (typeId == 58 || typeId == 65) {

            $('#HomeAutomationStatisticsModal').modal('show');
        } else if (typeId == 61 || typeId == 77) {

            $('#AirQualityStatisticsModal').modal('show');
        } else if (typeId == 72) {

            $('#AirQualityStatisticsModal').modal('show');
        } else if (typeId == 231) {

            $('#AcPlugStatisticsModal').modal('show');

        } else {
            $('#GenericStatisticsModal').modal('show');
        }

    }

    //todo: replace typeId with humanize names
    statisticalCheckByType(typeId) {

        let isStatistical = false;

        if (typeId == 58 || typeId == 231 || typeId == 61 || typeId == 65 || typeId == 72 || typeId == 77) {

            isStatistical = true;

        }

        return isStatistical;

    }

    // --- Remote Access API functions ------------------------------------------------------------

    getUsers() {
        return this._RemoteAccessService.getUsers(this.panelId);
    }

    getTroubles() {
        return this._RemoteAccessService.getTroubles(this.panelId);
    };

    genericSetArea(areaId, state, force = false) {

        return this._RemoteAccessService.setArea(this.panelId, areaId, state, force)
    }

    arm(areaId, force = false) {

        return this.genericSetArea(areaId, "arm", force);
    }

    forceArm(areaId) {

        return this.genericSetArea(areaId, "arm", true);
    }

    disarm(areaId) {

        return this.genericSetArea(areaId, "disarm");
    }

    forceDisarm(areaId) {

        return this.genericSetArea(areaId, "disarm", true);
    }

    stayArm(areaId) {

        return this.genericSetArea(areaId, "stay");
    }

    forceStayArm(areaId) {

        return this.genericSetArea(areaId, "stay", true);
    }

    setPanicAlarm() {

        return this._RemoteAccessService.setPanicAlarm(this.panelId);
    }

    getPanicAlarmState() {

        return this._RemoteAccessService.getPanicAlarmState(this.panelId);
    }

    getZonesConfigList() {

        return this._RemoteAccessService.getZonesConfigList(this.panelId);
    }

    getAreasConfigList() {

        return this._RemoteAccessService.getAreasConfigList(this.panelId);
    }

    setZoneBypass(zoneId, bypass) {

        return this._RemoteAccessService.setZoneBypass(this.panelId, zoneId, bypass);
    }

    getOutputsConfigList() {

        return this._RemoteAccessService.getOutputsConfigList(this.panelId);
    }

    getDoorLocks() {
        return this._RemoteAccessService.getDoorLocksConfigList(this.panelId);
    }

    getKeypadsConfigList() {
        return this._RemoteAccessService.getKeypadsConfigList(this.panelId);
    }

    setOutput(panelId, outputId, state) {
        return this._RemoteAccessService.setOutput(panelId, outputId, state);
    }

    setDoorLock(panelId, doorLockId, state) {
        return this._RemoteAccessService.setDoorLock(panelId, doorLockId, state);
    }

    castDateTime(dateTimeString) {

        return dateTimeString && new Date(dateTimeString);
    }

    _isCurrentInterfaceId(interfaceKey) {

        let currentKeyName = this.INTERFACES[interfaceKey];

        return _.some(currentKeyName, ['keyName', this.currentGraphType]);
    }

    // --- Generic helpers ----------------------------------------

    initTroubles() {

        this.isTroubled = null;
        this.adjustedTroubles = [];
    }

    adjustTroublesNames() {

        this.initTroubles();

        for (let pair of Object.keys(this.currentTroubles)) {

            this.isTroubled = this.isTroubled || this.currentTroubles[pair];
            this.adjustedTroubles.push({name: pair, isTroubled: this.currentTroubles[pair]});
        }
    }

    getTranslatableText(text) {

        return this.LanguageService.getTranslatableText(text)
    }

    getFilteredTroubles(obj, keysArray) {

        let troubles = [];

        for (let trouble in obj) {
            if (~keysArray.indexOf(trouble) && obj[trouble] == true) {

                troubles.push(this.getTranslatableText(trouble.replace('state', 'open')));
            }
        }
        return troubles.toString();
    }

    getFilteredZonesTroubles(obj) {

        let troubles = this.getFilteredTroubles(obj, this.ControlPanelConfigService.ZONE_TROUBLES);

        if (troubles.length > 0) {
            this.zoneTroubleDetected = true;
        }

        return troubles;
    }

    getFilteredOutputsTroubles(obj) {

        let troubles = this.getFilteredTroubles(obj, this.ControlPanelConfigService.OUTPUT_TROUBLES);

        if (troubles.length > 0) {
            this.outputTroubleDetected = true;
        }

        return troubles;
    }

    getFilteredKeypadsTroubles(obj) {

        let troubles = this.getFilteredTroubles(obj, this.ControlPanelConfigService.KEYPAD_TROUBLES);

        if (troubles.length > 0) {
            this.keypadTroubleDetected = true;
        }

        return troubles;
    }

    getFilteredUsersTroubles(obj) {

        let troubles = this.getFilteredTroubles(obj, this.ControlPanelConfigService.USER_TROUBLES);

        if (troubles.length > 0) {
            this.userTroubleDetected = true;
        }

        return troubles;
    }

    closeModal(modalName) {
        this.UiHelper.closeModal(modalName);
    }

    showModal(modalName) {
        this.UiHelper.showModal(modalName);
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/generic.controller.js
 **/